/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { Footer } from "../footer";
import get from "lodash/get";
import { HtmlSnippet } from "../html-snippet";
import "./footer-two.module.css";
import { SubscribeButton, SocialFollowWrapper, DefaultMenu, Monogram } from "../footer-helper-components";
import { MobileDownloadLinks } from "../../../atoms/mobile-apps";
import { breakpoint } from "../../../../../../app/utils/breakpoint";

const FooterTemplateTwo = props => {
  const copyrightText = get(props.publisherSettings, ["copyright"], "");
  const showFooterQuintypeLink = get(props.publisherTheme, ["footer-quintype-link"], "true") === "true";
  const bannerSource = get(props.publisherTheme, ["banner-source"], "");
  const footerMenu = props.menu.filter(item => item["menu-group-slug"] === "footer");
  const publisherName = get(props, ["publisherName"], "");
  return (
    <div>
      {bannerSource && <HtmlSnippet bannerSource={bannerSource} />}
      <footer styleName="wrapper" data-testid="footer">
        <div styleName="content container">
          <div data-testid="footer-logo-wrapper">
            <Monogram {...props} />
          </div>
          {!breakpoint("mobile") && (
            <>
              <div data-testid="footer-social-share-wrapper" styleName="social-share-wrapper">
                <p styleName="social-share-text">Follow Us</p>
                <SocialFollowWrapper {...props} />
              </div>
              {props.enableAppDownloadLinks && (
                <div styleName="download-links">
                  <MobileDownloadLinks {...props} />
                </div>
              )}
              <SubscribeButton {...props} />
            </>
          )}
        </div>
        <div data-testid="default-menu" styleName="default-menu">
          <DefaultMenu {...props} />
        </div>
        {breakpoint("mobile") && (
          <div styleName="content container">
            {props.enableAppDownloadLinks && (
              <div styleName="download-links">
                <MobileDownloadLinks {...props} />
              </div>
            )}
            <div data-testid="footer-social-share-wrapper" styleName="social-share-wrapper">
              <p styleName="social-share-text">Follow Us</p>
              <SocialFollowWrapper {...props} />
            </div>
            <SubscribeButton {...props} />
          </div>
        )}
        <div styleName="menu-wrapper">
          <ul styleName="menu">
            {footerMenu.map((item, index) => {
              return (
                <li data-testid="footer-menu-item" key={index}>
                  <a href={item.completeUrl}>{item.title}</a>
                </li>
              );
            })}
          </ul>
          <div styleName="copyright-text-wrapper">
            <p styleName="copyright-text">{copyrightText}</p>
            {showFooterQuintypeLink && (
              <a
                data-testid="copyright-link"
                styleName="copyright-link"
                href={`https://www.quintype.com/?utm_source=${publisherName}&utm_medium=footerlink&utm_campaign=poweredby`}
                target="_blank"
                rel="noopener nofollow"
              >
                <p>Powered by quintype</p>
              </a>
            )}
          </div>
        </div>
      </footer>
    </div>
  );
};

FooterTemplateTwo.propTypes = {
  menuItems: PropTypes.array,
  languageDirection: PropTypes.string,
  toggleSidebar: PropTypes.func,
  closeAll: PropTypes.func,
  enableAccesstype: PropTypes.boolean,
  enableAppDownloadLinks: PropTypes.boolean,
  publisherName: PropTypes.string,
  publisherSettings: PropTypes.shape({
    copyright: PropTypes.string
  }),
  publisherTheme: PropTypes.shape({
    "footer-quintype-link": PropTypes.string,
    "banner-source": PropTypes.string,
    monogram: PropTypes.string,
    footer_theme: PropTypes.string
  }),
  menu: PropTypes.array,
  socialLinks: PropTypes.object
};

const FooterTemplate = () => <Footer renderTemplate={FooterTemplateTwo} />;

export default FooterTemplate;
